import { type RouteRecordRaw } from "vue-router";

export const Routes = Object.freeze({
  index: "/ad",
  login: "/ad/login",
  content: {
    index: "/ad/content",
    home: '/ad/content/home',
    product: '/ad/content/product',
    application: '/ad/content/application',
    news: '/ad/content/news',
  },
  other: {
    index: '/ad/other',
    logo: '/ad/other/logo',
    nav: '/ad/other/nav',
    banner: '/ad/other/banner',
  },
  account: '/ad/account',
} as const);

const Layout = () => import("@/apps/admin/layout/Layout.vue");

export const Records: RouteRecordRaw[] = [
  {
    path: Routes.index,
    redirect: Routes.content.home,
  },
  {
    path: Routes.login,
    component: () => import("@/apps/admin/pages/Login.vue")
  },
  {
    path: Routes.content.index,
    component: Layout,
    redirect: Routes.content.home,
    meta: {
      title: '导航内容'
    },
    children: [
      {
        path: Routes.content.home,
        component: () => import("@/apps/admin/pages/content/Home.vue"),
        meta: {
          title: '首页版块'
        },
      },
      {
        path: Routes.content.product,
        component: () => import("@/apps/admin/pages/content/Product/Index.vue"),
        meta: {
          title: '产品中心'
        },
      },
      {
        path: Routes.content.application,
        component: () => import("@/apps/admin/pages/content/Application.vue"),
        meta: {
          title: '应用领域'
        },
      },
      {
        path: Routes.content.news,
        component: () => import("@/apps/admin/pages/content/News.vue"),
        meta: {
          title: '新闻动态'
        },
      },
    ]
  },
  {
    path: Routes.other.index,
    component: Layout,
    redirect: Routes.other.logo,
    meta: {
      title: '其他设置'
    },
    children: [
      {
        path: Routes.other.logo,
        component: () => import("@/apps/admin/pages/other/Logo.vue"),
        meta: {
          title: 'LOGO'
        },
      },
      {
        path: Routes.other.nav,
        component: () => import("@/apps/admin/pages/other/Nav.vue"),
        meta: {
          title: '导航'
        },
      },
      {
        path: Routes.other.banner,
        component: () => import("@/apps/admin/pages/other/Banner.vue"),
        meta: {
          title: '轮播图'
        },
      },
    ]
  },
  {
    path: Routes.account,
    component: Layout,
    children: [
      {
        path: Routes.account,
        component: () => import("@/apps/admin/pages/Account.vue"),
        meta: {
          title: '修改密码'
        },
      }
    ]
  }
];
